import React from 'react';
import { connect } from 'react-redux';
import { makeStyles } from '@material-ui/core/styles';
import { Box, Typography, Grid, Divider, Link } from '@material-ui/core';
import PanelTemplate from '../../common/PanelTemplate';
import { get, isEmpty } from '../../../utils/lodash';
import I18n from '../../../config/locales';
import { getToken, decodeToken, getCountryBasedLink } from '../../../utils/helper';
import analytics from '../../../utils/analytics';

const useStyles = makeStyles(theme => ({
  scoreCardBody: {
    padding: theme.spacing(0, 0, 1, 2.5),
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fill, minmax(123px, 1fr))',
    gridColumnGap: theme.spacing(0.25),
    gridRowGap: theme.spacing(1.5),
    [theme.breakpoints.down('xs')]: {
      gridTemplateColumns: 'repeat(auto-fill, minmax(120px, 1fr))',
      gridRowGap: theme.spacing(2.5)
    }
  },
  scoreCardWrapper: {
    position: 'relative',
    padding: theme.spacing(1, 1, 1, 0.5)
  },
  scoreCardHeader: {
    color: theme.palette.primary.main,
    fontSize: 18,
    fontWeight: 'bold',
    padding: theme.spacing(1, 0, 0, 2),
    width: 'calc(100% - 150px)',
    letterSpacing: 0.8
  },
  caseName: {
    opacity: 0.6,
    fontSize: 13,
    [theme.breakpoints.down('xs')]: {
      textAlign: 'center'
    }
  },
  caseCount: {
    color: theme.palette.primary.main,
    fontSize: theme.spacing(2),
    [theme.breakpoints.down('xs')]: {
      textAlign: 'center'
    }
  },
  displayFlex: {
    display: 'flex',
    paddingTop: theme.spacing(0.6)
  },
  viewDetails: {
    color: theme.palette.primary.blue,
    padding: theme.spacing(1, 0, 0, 2),
    textDecoration: 'none',
    fontSize: theme.spacing(1.65),
    cursor: 'pointer'
  }
}));

const ServiceManagerCases = props => {
  const classes = useStyles();
  const gaAnalytics = new analytics();
  let totalCases = 'NA',
    submittedCases = 'NA',
    inProgressCases = 'NA',
    completedCases = 'NA';
  if (!isEmpty(props.serviceManagerCases)) {
    totalCases = get(props.serviceManagerCases, 'total_cases', 0);
    submittedCases = get(props.serviceManagerCases, 'new_cases', 0);
    inProgressCases = get(props.serviceManagerCases, 'in_progress_cases', 0);
    completedCases = get(props.serviceManagerCases, 'closed_cases', 0);
  }

  const handleContextMenu = (event) => {
    event.preventDefault();
  };

  const trackEvent = () => {
    gaAnalytics.triggerEvent({ event: 'triggerViewDetailsServiceRequests' });
    if (window.build_environment === 'qa2' || window.build_environment === 'production') {
      serviceManagerLogin()
      return false;
    }
  };

  function redirectToServiceManagerLink(url) {
    window.open(url, '_blank');
  }

  const serviceManagerLogin = async () => {
    const token = getToken();
    const { session_id: sessionId, email_id: username } = decodeToken(token);
    let smBaseUrl = getCountryBasedLink('serviceManagerBaseUrl')

    // var smSiteUrl = `${smBaseUrl}/${locale}/systems/${site_id}`;
    // var smLoginUrl = `${smBaseUrl}/${locale}/?login=y`;

    var smLoginUrlWithoutLocale = `${smBaseUrl}/?login=y`;
    var smDashboardUrlWithoutLocale = `${smBaseUrl}/`;

    // var myHeaders = new Headers();
    // myHeaders.append("Cookie", `sm_locale=${locale}`);

    var requestOptions = {
      method: 'GET',
      // headers: myHeaders,
      redirect: 'follow',
      credentials: 'include'
    };

    await fetch(`${smBaseUrl}/api/internal/validate_session`, requestOptions)
      .then(response => {
        if (response.status === 200) {
          // Valid session available, redirect to the service manager link, auto login
          redirectToServiceManagerLink(smDashboardUrlWithoutLocale);
        }
        else if (response.status === 401 || response.status === 403) {
          // No valid session, authenticate and redirect
          var myHeaders = new Headers();
          myHeaders.append("Content-Type", "application/x-www-form-urlencoded");
          var urlencoded = new URLSearchParams();
          urlencoded.append("username", username);
          urlencoded.append("password", sessionId);
          var requestOptions = {
            method: 'POST',
            headers: myHeaders,
            body: urlencoded,
            redirect: 'follow',
            credentials: 'include'
          };
          fetch(`${smBaseUrl}/users/auth/enlighten`, requestOptions)
            .then(response => {
              if (response.status === 200) {
                // Authenticated, redirect to the service manager link, auto log in
                redirectToServiceManagerLink(smDashboardUrlWithoutLocale);
              }
              else {
                // redirect to the service manager link, user should manually log in
                redirectToServiceManagerLink(smLoginUrlWithoutLocale);
              }
            })
            .catch(error => {
              redirectToServiceManagerLink(smDashboardUrlWithoutLocale);
            })
        }
        else {
          // API call failed, redirect for manual login
          redirectToServiceManagerLink(smLoginUrlWithoutLocale);
        }
      })
      .catch(error => {
        redirectToServiceManagerLink(smLoginUrlWithoutLocale);
      })
  }

  return (
    <PanelTemplate header={I18n.t('dashboard.serviceRequests')} boxShadow id="serviceRequestsBox">
      <Box className={classes.scoreCardWrapper}>
        <Grid container className={classes.scoreCardBody}>
          <Box>
            <Typography component="div" className={classes.caseName}>
              {I18n.t('dashboard.totalCases')}
            </Typography>
            <Typography component="div" className={classes.caseCount}>
              {totalCases}
            </Typography>
          </Box>
          <Box>
            <Typography component="div" className={classes.caseName}>
              {I18n.t('dashboard.new')}
            </Typography>
            <Typography component="div" className={classes.caseCount}>
              {submittedCases}
            </Typography>
          </Box>
          <Box>
            <Typography component="div" className={classes.caseName}>
              {I18n.t('dashboard.inProgressRequests')}
            </Typography>
            <Typography component="div" className={classes.caseCount}>
              {inProgressCases}
            </Typography>
          </Box>
          <Box>
            <Typography component="div" className={classes.caseName}>
              {I18n.t('dashboard.resolvedRequests')}
            </Typography>
            <Typography component="div" className={classes.caseCount}>
              {completedCases}
            </Typography>
          </Box>
        </Grid>
        <Divider />
        <Box className={classes.displayFlex}>
          <Link
            href={(window.build_environment !== 'qa2' && window.build_environment !== 'production') ? getCountryBasedLink('serviceManager') : undefined}
            onClick={() => trackEvent()}
            target="_blank"
            className={classes.viewDetails}
            onContextMenu={handleContextMenu}
          >
            {I18n.t('dashboard.viewDetails')}
          </Link>
        </Box>
      </Box>
    </PanelTemplate>
  );
};

const mapDispatchToProps = dispatch => ({});

const mapStateToProps = state => ({
  serviceManagerCases: state.dashboardReducer.serviceManagerCases
});

export default connect(mapStateToProps, mapDispatchToProps)(ServiceManagerCases);
